export default __webpack_public_path__ + "static/media/rambouillet27.5489f2e7.jpg";